/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_ResendInputs */

const en_invite_x15_resend = /** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send the link again`)
};

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const ar_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const he_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const ur_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const es_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const fr_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const de_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const pt_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const hi_invite_x15_resend = en_invite_x15_resend;

/** @type {(inputs: Invite_X15_ResendInputs) => LocalizedString} */
const bn_invite_x15_resend = en_invite_x15_resend;

/**
* | output |
* | --- |
* | "Send the link again" |
*
* @param {Invite_X15_ResendInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_resend = /** @type {((inputs?: Invite_X15_ResendInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_ResendInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_resend(inputs)
	if (locale === "he") return he_invite_x15_resend(inputs)
	if (locale === "ur") return ur_invite_x15_resend(inputs)
	if (locale === "es") return es_invite_x15_resend(inputs)
	if (locale === "fr") return fr_invite_x15_resend(inputs)
	if (locale === "de") return de_invite_x15_resend(inputs)
	if (locale === "pt") return pt_invite_x15_resend(inputs)
	if (locale === "hi") return hi_invite_x15_resend(inputs)
	if (locale === "bn") return bn_invite_x15_resend(inputs)
	return /** @type {LocalizedString} */ ("Send the link again")
});